/// <amd-module name="Build/Pipelines/Components/DateAndDuration" />
import * as React from "react";

import { format } from "VSS/Core/Util/String";

import { Ago } from "VSSUI/Ago";
import { Duration } from "VSSUI/Duration";
import { Icon } from "VSSUI/Icon";
import { TwoLineTableCell, ITableColumn, SimpleTableCell } from "VSSUI/Table";
import { AgoFormat, tooltipString } from "VSSUI/Utilities/Date";

import * as Resources from "Build/Pipelines/Resources";

export interface IDateAndDurationProps {
    queueTime: Date;
    startTime?: Date;
    finishTime?: Date;
    columnIndex: number;
    tableColumn: ITableColumn<any>;
}

export class DateAndDuration extends React.Component<IDateAndDurationProps, {}> {

    public render() {
        const { columnIndex, finishTime, queueTime, startTime, tableColumn } = this.props;

        const dateLine = (
            <div className="flex-row flex-center fontSize">
                <Icon iconName="DateTime2" className="icon-margin" />
                <Ago 
                    date={queueTime} 
                    format={AgoFormat.Compact} 
                    tooltipProps={{ renderContent: function() { return format(Resources.AgoTooltip, tooltipString(queueTime)); }}} 
                />
            </div>
        );

        if (!startTime) {
            return (
                <SimpleTableCell columnIndex={columnIndex} tableColumn={tableColumn}>
                    {dateLine}
                </SimpleTableCell>
            );
        }

        const durationLine = (
            <div className="flex-row flex-center fontSize bolt-table-two-line-cell-item">
                <Icon iconName="Stopwatch" className="icon-margin" />
                <Duration 
                    startDate={startTime} 
                    endDate={finishTime} 
                    tooltipProps={{ renderContent: function() { return format(Resources.DurationTooltip, tooltipString(startTime)); }}} 
                />
            </div>
        );

        return (
            <TwoLineTableCell columnIndex={columnIndex} tableColumn={tableColumn} line1={dateLine} line2={durationLine} />
        );
    }
}